/**
 * Defines behavior for sections with tab navigation.
 *
 * Uses SwiperJS to make tab navigation draggable on small screens.
 *
 * @todo - Move active tab and tab content behavior from qustodio-divi-extension.
 */
import dom from '../helpers/dom';
import divi from '../helpers/divi';

const dragOnOverflow = (tabSections) => {
  const breakpoint = 980; // From: assets/src/scss/public/breakpoints.scss.
  let swiperInstances = [];
  let isEnabled = false;

  const meetsCondition = () => {
    const windowWidth = window.innerWidth;
    return windowWidth <= breakpoint;
  };

  const enable = () => {
    if (!isEnabled) {
      tabSections.forEach((tabSection) => {
        swiperInstances.push(new Swiper(tabSection, {
          slidesPerView: 'auto',
          freeMode: true,
          spaceBetween: 8,
        }));
      });
      isEnabled = true;
    }
  };

  const disable = () => {
    if (isEnabled) {
      swiperInstances.forEach((swiperInstance) => {
        swiperInstance.destroy();
      });
      swiperInstances = [];
      isEnabled = false;
    }
  };

  const maybeEnable = () => (meetsCondition() ? enable() : disable());

  return {
    maybeEnable,
  };
};

const tabs = () => {
  const tabSectionClassname = 'js-qusd-tabs-wrapper';
  const tabClassname = 'js-qusd-tab';
  const swiperSlideClass = 'swiper-slide';
  let tabSections = [];
  let tabSectionsFound = false;
  let dragOnOverflowHanlder;

  /*
   * Divi adds `<div>` wrappers around our tabs, which breaks SwiperJS, as it
   * needs elements with the `swiper-slide` to be direct children of the element
   * with the `swiper` class.
   *
   * This function checks if the tab is inside a Divi module, and moves the
   * class if necessary.
   */
  const maybeMoveSwiperClass = (tabSection) => {
    if (divi.isInsideModuleWrapper(tabSection)) {
      const tabElements = dom.getByClassName(tabClassname, tabSection);
      tabElements.forEach((tab) => {
        const tabGrandparent = tab.parentNode.parentNode;
        tab.classList.remove(swiperSlideClass);
        tabGrandparent.classList.add(swiperSlideClass);
      });
    }
  };

  const init = () => {
    tabSections = dom.getByClassName(tabSectionClassname);
    tabSectionsFound = tabSections.length > 0;
    if (tabSectionsFound) {
      tabSections.forEach((tabSection) => maybeMoveSwiperClass(tabSection));
      dragOnOverflowHanlder = dragOnOverflow(tabSections);
      dragOnOverflowHanlder.maybeEnable();
    }
  };

  const onResize = () => {
    if (tabSectionsFound) {
      dragOnOverflowHanlder.maybeEnable();
    }
  };

  return {
    init,
    onResize,
  };
};

export default tabs();
